module.exports = __webpack_public_path__ + "img/火龙果1.6dda521d.png";